import React from 'react';
import s from './Servicios.module.css';
import ServiciosCard from '../ServiciosCard/ServiciosCard';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default function Servicios({data}) {

    if(!data.length){
        return (
            <header className={s.section}>
                <LoadingSpinner/>
            </header>
        )
    }

  return (
    <section className={s.section} id="Servicios">
        <h3>Servicios</h3>
        <div className={s.grid}>
            {
                data?.map((s,i)=>{
                    return <ServiciosCard key={i} servicio={s}/>
                })
            }
        </div>
    </section>
  )
}
